import React, { useEffect, useState } from "react";
import { animalAssets } from'../../../services/constant';
const Collapse = ({ open, children, data , isOpen, setIsOpen }) => {
    
    const [insuree, setInsuree] = useState([]);
    const handleFilterOpening = () => {
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        if (data.insuree)
            setInsuree({
                name: data.insuree.properties[0].data,
                nif: data.insuree.properties[1].data,
                telephone: data.insuree.properties[3].data,
                email: data.insuree.properties[2].data,
                address: data.insuree.properties[4].data,
                code: data.insuree.properties[5].data,
                city: data.insuree.properties[6].data
            });
    }, [data])

    function formatPhoneNumber(phoneNumber) {
        if (phoneNumber) {
            // Check if the phone number starts with a '+', which indicates the country code
            if (phoneNumber.startsWith('+')) {
                // Extract the country code (first 4 characters) and the remaining part
                const countryCode = phoneNumber.slice(0, 4);
                const mainNumber = phoneNumber.slice(4);

                // Format the main part of the number in groups of 3 digits
                const formattedNumber = mainNumber.replace(/(\d{3})(?=\d)/g, '$1 ');

                // Combine the country code with the formatted main number
                return `${countryCode} ${formattedNumber}`;
            } else {
                // If the phone number doesn't start with a '+', return it as is
                return phoneNumber;
            }
        }
    }

    return (
        <>
            <div className="collagse_card">
                <div>
                    <div className={isOpen ? " border-bottom collapse_header active" : " border-bottom collapse_header in_active"}>

                        <button type="button" className="btn_down" onClick={handleFilterOpening}>
                            <img src={animalAssets.ic_user1} className="btn_icon" alt="" />
                            <span className="btn_title font-14-400"> Tomador</span> <span className="btn_content font-15-600">{insuree.name}</span>
                            <span className="btn_title font-14-400"> NIF </span> <span className="btn_content font-15-600">{insuree.nif}</span>
                            <span className="btn_title font-14-400"> Telefone </span> <span className="btn_content font-15-600">{formatPhoneNumber(insuree.telephone)}</span>
                            <span className="btn_title font-14-400"> Email  </span> <span className="btn_content font-15-600">{insuree.email}</span>
                            {!isOpen ? (
                                <div className="btn_ic">  <img src={animalAssets.ic_arrow_down} alt=""></img></div>
                            ) : (
                                <div className="btn_ic"> <img src={animalAssets.ic_arrow_up} alt="" ></img></div>
                            )}
                        </button>
                    </div>
                </div>

                <div className="">
                    <div>{isOpen && <div>
                        <div className="p-25">
                            <div className="info_title mb-3">
                                <span className="font-color1 font-12-900 mr-10">DADOS DO TOMADOR </span>
                            </div>
                            <div className=" flex-row mb-34">
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Nome</span>
                                    <span className="font-color font-14-500 font-left">{insuree.name} </span>
                                </div>
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">País</span>
                                    <span className="font-color font-14-500 font-left">{insuree.nif}</span>
                                </div>
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Contacto Móvel</span>
                                    <span className="font-color font-14-500 font-left">{formatPhoneNumber(insuree.telephone)}</span>
                                </div>
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Email</span>
                                    <span className="font-color font-14-500 font-left">{insuree.email}</span>
                                </div>
                            </div>
                            <div className=" flex-row">
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Morada</span>
                                    <span className="font-color font-14-500 font-left">{insuree.address}</span>
                                </div>
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Código Postal</span>
                                    <span className="font-color font-14-500 font-left">{insuree.code}</span>
                                </div>
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Localidade</span>
                                    <span className="font-color font-14-500 font-left">{insuree.city}</span>
                                </div>
                                <div className="flex-column w-25">
                                    <span className="font-color1 font-13-500 mb-2">Distrito</span>
                                    <span className="font-color font-14-500 font-left">Lisboa</span>
                                </div>
                            </div>
                            <div className="dotline_divider mt-4"></div>
                            <div>
                                <div className="info_title mb-3">
                                    <span className="font-color1 font-12-900 mr-10">MORADA </span>
                                </div>
                                <div className=" flex-row mb-34">
                                    <div className="flex-column w-25">
                                        <span className="font-color1 font-13-500 mb-2">Rua</span>
                                        <span className="font-color font-14-500 font-left">{insuree.address} </span>
                                    </div>
                                    <div className="flex-column w-25">
                                        <span className="font-color1 font-13-500 mb-2">Código Postal</span>
                                        <span className="font-color font-14-500 font-left">{insuree.code}</span>
                                    </div>
                                    <div className="flex-column w-25">
                                        <span className="font-color1 font-13-500 mb-2">Cidade</span>
                                        <span className="font-color font-14-500 font-left">{insuree.city}</span>
                                    </div>
                                    <div className="flex-column w-25">
                                        <span className="font-color1 font-13-500 mb-2">Pais</span>
                                        <span className="font-color font-14-500 font-left">Portugal</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}</div>
                </div>
            </div>
        </>
    );
};

export default Collapse;